<template>
	<div class="homecontainer" v-if="this.showHome">
        <div class="subcontainer">
            <div class="subcontainerheader">
                <div class="heading">Track shipments</div>
                <div class="subheading">Check the delivery status of a shipment</div>
            </div>
            <form @submit.prevent="search">
                <div class="search">
                    <img src="../../static/shipment-search.png" />
                    <input name="Id" type="text" placeholder="Enter consignment number" v-model="id" required />
                    <button type="submit" class="ripple">Track shipment</button>
                </div>
            </form>
        </div>
	</div>
    <div v-else>
        <tracking-search :connote="this.id" :account="this.accountId"></tracking-search>        
    </div>
</template>

<script>
	export default {
		props: {
            connote: { type: String, default: null },
            account: { type: Number, default: null }
		},
        data() {
            var urlQueryParams = new URLSearchParams(window.location.search);

			return {
                id: "",
                accountId: urlQueryParams.get('account'),
                showHome: true
			}
		},
        mounted() {
			if (this.connote) {
                this.id = this.connote
                this.accountId = this.account
				this.search()
			}
		},
		methods:
		{
			search() {
                this.showHome = false
			}
		}
	}
</script>

<style lang="scss" scoped>
    .subcontainer {        
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0px;
    }
    .heading {
        font-family: Interstate;
        color: #000000;
        font-style: normal;
        font-weight: bold;
        font-size: 35.16px;
        line-height: 39px;
    }
    .subheading {
        font-family: Inter;
        color: #27374E;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        margin: 24px 0px;
    }
    .search {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px;
        position: static;
    }
</style>